import lodashGet from "lodash/get";
import lodashHas from "lodash/has";
import lodashCloneDeep from "lodash/cloneDeep";

import {
  getNotifications,
  addNotification,
  updateNotification,
  deleteNotification,
} from "@/services/notifications/notifications.service";
import { NOTIFICATION_TYPE_SAVED_SEARCH } from "@/common/constants/notifications";

export { _saveSearchQuery as saveSearchQuery };
export { _getSavedSearchList as getSavedSearchList };
export { _deleteSearchQuery as deleteSearchQuery };
export { _updateSearchQuery as updateSearchQuery };
export { _getKeywordsStringFromBuilder as getKeywordsStringFromBuilder };

const _saveSearchQuery = async (params) => {
  try {
    params.formatted = params.formatted || {};
    params.formatted.docType = NOTIFICATION_TYPE_SAVED_SEARCH;
    params.formatted.enabled = false;
    params.formatted.name = params.name;
    return await addNotification(params);
  } catch (error) {
    console.error("Unable to create search query", error);
    return false;
  }
};

const _getSavedSearchList = async () => {
  try {
    return await getNotifications({
      type: [{ value: NOTIFICATION_TYPE_SAVED_SEARCH }],
    });
  } catch (error) {
    console.error("Unable to get users saved search", error);
    return false;
  }
};

const _deleteSearchQuery = async (params) => {
  try {
    if (!params || !params.id) {
      console.error("Unable to delete search query, id not set.");
      return false;
    }

    params.formatted = params.formatted || {};
    params.formatted.id = params.id;
    return await deleteNotification(params);
  } catch (error) {
    console.error("Unable to delete search query", error);
    return false;
  }
};

const _updateSearchQuery = async (params) => {
  try {
    if (!params || !params.id) {
      console.error("Unable to update search query, id not set.");
      return false;
    }

    params.formatted = params.formatted || {};
    params.formatted.docType = NOTIFICATION_TYPE_SAVED_SEARCH;
    params.formatted.id = params.id;
    if (params.data) {
      params.formatted.enabled = lodashHas(params, "data.enabled")
        ? params.data.enabled
        : false;
      params.formatted.name = lodashHas(params, "data.name")
        ? params.data.name
        : null;
      if (lodashHas(params, "data.sharedList")) {
        params.formatted.sharedList = lodashCloneDeep(params.data.sharedList);
      }
      if (lodashHas(params, "data.frequency")) {
        params.formatted.frequency = params.data.frequency;
      }
      if (lodashHas(params, "data.schedule")) {
        params.formatted.schedule = params.data.schedule;
      }
      if (lodashHas(params, "data.timeOfDay")) {
        params.formatted.timeOfDay = params.data.timeOfDay;
      }
      if (lodashHas(params, "data.dayOfWeek")) {
        params.formatted.dayOfWeek = params.data.dayOfWeek;
      }
      if (lodashHas(params, "data.expiration")) {
        params.formatted.expiration = params.data.expiration;
      }
      if (lodashHas(params, "data.expirationDate")) {
        params.formatted.expirationDate = params.data.expirationDate;
      }
      params.formatted.delivery = [];
      if (lodashHas(params, "data.useEmail")) {
        params.formatted.delivery.push("email");
      }
      if (lodashHas(params, "data.usePush")) {
        params.formatted.delivery.push("push");
      }
      if (lodashHas(params, "data.useIntegrations")) {
        params.formatted.delivery.push("target");
      }
      if (lodashHas(params, "data.integrationTargets")) {
        params.formatted.targets = params.data.integrationTargets;
      }
      if (lodashHas(params, "data.params")) {
        params.params = params.data.params;
      }
      delete params.data;
    }
    return await updateNotification(params);
  } catch (error) {
    console.error("Unable to update search query", error);
    return false;
  }
};

const _getKeywordsStringFromBuilder = (keywordsBuilder) => {
  let keywordsStr = "";
  if (keywordsBuilder) {
    let keywordsParts = [];
    if (lodashGet(keywordsBuilder, "includes")) {
      const includeGroups = [];
      keywordsBuilder.includes.forEach((group) => {
        if (lodashGet(group, "keywords") && group.keywords.length) {
          const includeWords = [];
          group.keywords.forEach((keyword) => {
            if (lodashGet(keyword, "text")) {
              includeWords.push(`"${keyword.text}"`);
            }
          });
          includeGroups.push(`+(${includeWords.join(" | ")})`);
        }
      });
      if (includeGroups.length) {
        keywordsParts.push(includeGroups.join(" "));
      }
    }
    if (lodashGet(keywordsBuilder, "excludes")) {
      const excludeWords = [];
      keywordsBuilder.excludes.forEach((keyword) => {
        if (lodashGet(keyword, "text")) {
          excludeWords.push(`-"${keyword.text}"`);
        }
      });
      keywordsParts.push(excludeWords.join(" "));
    }
    keywordsStr = keywordsParts.join(" ");
  }
  return keywordsStr;
};
